import { useNavigate } from 'react-router-dom'
import { useAppSelector } from 'app/hooks'
import {
  IRolePermissions,
  MessagingPermissions,
  NewsFeedPermissions,
  TeamAndChannelPermissions,
  VideoConferencePermissions,
} from 'types/role.types'
import { isFlagSetIn } from 'utils/helpers/isSetInFlags'
import { useEffect, useState } from 'react'

const usePermissionBasedNavigation = () => {
  const permissions = useAppSelector<IRolePermissions>((state) => state.auth.permissions)
  const [isReady, setIsReady] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const sum = Object.values(permissions).reduce((acc, value) => acc + value, 0)
    if (sum > 0) {
      setIsReady(true)
    }
  }, [permissions])

  if (!isReady) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return { navigateBasedOnPermissions: () => {}, isReady: false }
  }

  const hasNewsFeedViewPermission = isFlagSetIn(
    [NewsFeedPermissions.VIEW_NEWSFEED],
    permissions.newsFeed,
  )
  const hasVideoCallPermission = isFlagSetIn(
    [VideoConferencePermissions.VIEW_ALL_MEETING_LIST],
    permissions.videoConference,
  )
  const hasMessageViewPermission = isFlagSetIn(
    [MessagingPermissions.START_MESSAGING],
    permissions.messaging,
  )
  const hasTeamsViewPermission = isFlagSetIn(
    [TeamAndChannelPermissions.VIEW_TEAMS],
    permissions.teamAndChannel,
  )

  const navigateBasedOnPermissions = () => {
    if (hasNewsFeedViewPermission) {
      navigate('/news-feed')
    } else if (hasTeamsViewPermission) {
      navigate('/channels')
    } else if (hasMessageViewPermission) {
      navigate('/messages')
    } else if (hasVideoCallPermission) {
      navigate('/video-call')
    } else {
      navigate('/admin-panel/dashboard/general-view')
    }
  }

  return { navigateBasedOnPermissions, isReady }
}

export default usePermissionBasedNavigation
